import types from '../../actions/types'
import {combineReducers} from 'redux'
import {disableUseCostBreaks, enableUseCostBreaks, nullPart, parsePart} from 'helpers/parts'
import priceBreaks from './priceBreaks'
import {isNil} from 'lodash'
import {getSelectedPartPackId} from 'helpers/packs'
import partContents from './partContents'
import partSuppliers from './partSuppliers'
import partSupplierCostPriceBreaks from './partSupplierCostBreaks'
import Immutable from 'seamless-immutable'
import {DataType} from 'helpers/socket'

export const part = (state = nullPart, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_LOAD_PART_ATTEMPT:
      return null
    case types.PRICE_LISTS_LOAD_PART_SUCCESS:
      return parsePart(action.data)
    case types.PRICE_LISTS_LOAD_PART_FAILURE:
      return null
    case types.PRICE_LISTS_UPDATE_PART_SUCCESS:
      const part = action.data.result[0]
      return isNil(part)
          ? state
          : parsePart(part)
    case types.PRICE_LISTS_PART_UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        partImages: action.data,
      }
    case types.PRICE_LISTS_PART_REMOVE_IMAGE_SUCCESS:
      return {
        ...state,
        partImages: [],
      }
    case types.PRICE_LISTS_CHANGE_USE_COST_BREAKS: {
      return action.value
          ? enableUseCostBreaks(state, action.partPackId, action.isComplexPricingEnabled)
          : disableUseCostBreaks(state, action.partPackId, action.isComplexPricingEnabled)
    }
    default:
      return state
  }
}

export const isPartLoading = (state = false, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_LOAD_PART_ATTEMPT:
      return true
    case types.PRICE_LISTS_LOAD_PART_SUCCESS:
      return false
    case types.PRICE_LISTS_LOAD_PART_FAILURE:
      return false
    default:
      return state
  }
}

export const selectedPartPackId = (state = null, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SELECT_PART_PACK:
      return action.id
    case types.PRICE_LISTS_SELECT_PART:
      return null
    case types.PRICE_LISTS_LOAD_PART_SUCCESS:
      return getSelectedPartPackId(action.data)
    default:
      return state
  }
}

export const selectedPartSupplierId = (state = null, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SELECT_PART_SUPPLIER:
      return action.id
    case types.PRICE_LISTS_SELECT_PART:
      return null
    default:
      return state
  }
}

const observingPartId = (state = Immutable(null), action) => {
  switch (action.type) {

    // (optimistic)
    case types.OBSERVE_PART:
      return action.id

    // (optimistic)
    case types.OBSERVE:
      return action.dataType === DataType.PART
          ? action.objectId
          : state

      // (optimistic)
    case types.DEOBSERVE:
      return action.dataType === DataType.PART && parseInt(action.objectId) === state
          ? null
          : state

    default:
      return state
  }
}

export default combineReducers({
  part,
  isPartLoading,
  selectedPartPackId,
  selectedPartSupplierId,
  priceBreaks,
  partContents,
  partSuppliers,
  partSupplierCostPriceBreaks,
  observingPartId,
})
